<template>
  <VNavigationDrawer
    location="left"
    mobile-breakpoint="sm"
    v-model="drawer"
    class="console-sidemenu"
    :width="290"
    ref="drawerElement"
  >
    <div class="d-flex flex-column justify-space-between" style="height:100%">
      <div>
        <AccesspointSwitch>
        </AccesspointSwitch>

        <v-list class="console-navigation" density="default" nav data-cy="console-sidemenu-managementConsoleMenu">
          <v-list-subheader>
            <v-icon start>mdi-tune-vertical</v-icon>
            {{ $t('console.management_console') }}
          </v-list-subheader>

          <!-- TODO: Check the permissions -->
          <v-list-item to="/console/index" data-cy="console-sidemenu-myAccount">
            <template v-slot:prepend>
              <v-icon>mdi-account</v-icon>
            </template>
            {{ $t('console.my_account') }}
          </v-list-item>

          <v-list-item
            to="/console/users"
            v-if="!isTenantSubscriptionExpired && $canListUser()"
            :class="{ 'v-list-item--active': isActiveRoute('/console/users/permissions') }"
            data-cy="console-sidemenu-users"
          >
            <template v-slot:prepend>
              <v-icon>mdi-account-group</v-icon>
            </template>
            {{ $t('console.users') }}
          </v-list-item>


          <v-list-item to="/console/usage" v-if="$canControlTenantConfig()"
                       data-cy="console-sidemenu-resourceUsage">
            <template v-slot:prepend>
              <v-icon>mdi-home-analytics</v-icon>
            </template>
            {{ $t('console.resourceUsage') }}
          </v-list-item>

          <v-list-item to="/console/storage"
                       v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
                       data-cy="console-sidemenu-storageUsage">
            <template v-slot:prepend>
              <v-icon>mdi-database</v-icon>
            </template>
            {{ $t('console.storageUsage') }}
          </v-list-item>

          <v-list-item
            v-if="showingBrandingButton"
            to="/console/branding"
            data-cy="console-sidemenu-branding"
          >
            <template v-slot:prepend>
              <v-icon>mdi-watermark</v-icon>
            </template>
            {{ $t('menus.branding.branding') }}
          </v-list-item>

          <v-list-item
            to="/console/tenant-settings"
            v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
            data-cy="console-sidemenu-tenants-settings"
          >
            <template v-slot:prepend>
              <v-icon>mdi-cogs</v-icon>
            </template>
            {{ $t('console.tenantSettings') }}
          </v-list-item>

          <v-list-item
            to="/console/tenant-connections"
            v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
            data-cy="console-sidemenu-tenants-settings"
          >
            <template v-slot:prepend>
              <v-icon>mdi-cast-connected</v-icon>
            </template>
            {{ $t('console.connectedTennats') }}
          </v-list-item>

          <v-list-item
            to="/console/ftp-users"
            v-if="!isTenantSubscriptionExpired && $canListUser() && $canControlTenantConfig()"
            data-cy="console-sidemenu-ftpUsers"
          >
            <template v-slot:prepend>
              <v-icon>mdi-server</v-icon>
            </template>
            {{ $t('console.ftpUsers') }}
          </v-list-item>

          <v-list-item
            to="/console/labels"
            v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
            data-cy="console-sidemenu-labels"
          >
            <template v-slot:prepend>
              <v-icon>mdi-label-multiple</v-icon>
            </template>
            {{ $t('console.labels') }}
          </v-list-item>

          <v-list-item
            to="/console/api-clients"
            v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
            data-cy="console-sidemenu-apiClients"
          >
            <template v-slot:prepend>
              <v-icon>mdi-key-chain</v-icon>
            </template>
            {{ $t('console.apiClients') }}
          </v-list-item>

          <v-list-item
            to="/console/webhook-integrations"
            v-if="!isTenantSubscriptionExpired && $canControlTenantConfig()"
            data-cy="console-sidemenu-webhookIntegrations"
          >
            <template v-slot:prepend>
              <v-icon>mdi-webhook</v-icon>
            </template>
            {{ $t('console.webhookIntegrations') }}
          </v-list-item>
        </v-list>
      </div>

      <div v-if="isTenantSubscriptionExpired" class="text-center">
        <v-icon size="64" color="deep-orange" class="mb-4">mdi-alert</v-icon>
        <v-alert variant="outlined" color="deep-orange">
          {{ $t('routes.expired.tenantAccountExpired') }}
          <a href="mailto:accounts@tubeway.io">accounts@tubeway.io</a>.
        </v-alert>
      </div>

      <div v-if="showingUpgradeButton" class="d-flex flex-column text-center">
        <span v-if="getSubscriptionDaysLeft">
          {{ $t('layouts.main.subscriptionDaysLeft', getSubscriptionDaysLeft) }}
        </span>
        <v-btn color="primary" variant="elevated" @click="openSubscriptionContactDialog">
          <v-icon start>mdi-crown-circle</v-icon>
          {{$t('layouts.main.upgradeSubscription')}}
        </v-btn>
      </div>
    </div>
  </VNavigationDrawer>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useMainStore } from '@/stores/MainStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import { useTenantStore } from '@/stores/TenantStore.js'
import AccesspointSwitch from '../components/AccesspointSwitch.vue'

export default {
  name: "ConsoleSidemenu",
  components: {
    AccesspointSwitch,
  },
  props: {
    subscriptionType: {
      type: String,
      required: true,
    },
    subscriptionName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      drawer: null,
    };
  },
  watch: {
    getSidemenuToggle() {
      this.drawer = !this.drawer;
    }
  },
  methods: {
    isActiveRoute(route) {
      return this.$route.path === route;
    },
    openSubscriptionContactDialog() {
      const mainStore = useMainStore();
      mainStore.showSubscriptionContactDialog();
    },
  },
  computed: {
    getSidemenuToggle() {
      const mainStore = useMainStore();
      return mainStore.getSidemenuToggle;
    },
    getRecurringSubscriptionTypes: function() {
      const tenantStore = useTenantStore();
      return tenantStore.getRecurringSubscriptionTypes;
    },
    showingUpgradeButton() {
      const systemStore = useSystemStore();
      const getSubscription = systemStore.getSubscription;

      return this.$canControlTenantConfig() &&
              !this.$isFCPExtension() &&
              !this.$isAdobeExtension() &&
              getSubscription &&
              getSubscription.subscription &&
              getSubscription.subscription.name &&
              getSubscription.subscription.name === 'trial';
    },
    showingBrandingButton() {
      return !this.isTenantSubscriptionExpired
        && this.$canControlTenantConfig()
        && this.getRecurringSubscriptionTypes.includes(this.subscriptionType);
    },
    getSubscriptionDaysLeft() {
      const authStore = useAuthStore();
      const activeTenant = authStore.getActiveTenant;
      if (activeTenant?.subscription?.subscriptionEnd) {
        return activeTenant.subscription.subscriptionEnd.days <= 0
          ? 0
          : activeTenant?.subscription?.subscriptionEnd?.days;
      }

      return 0;
    },
    isTenantSubscriptionExpired() {
      const authStore = useAuthStore();
      return authStore.tenantIsExpired;
    },
  },
}
</script>

<style scoped>
.console-sidemenu {
  position: fixed !important;
  top: 0 !important;
  bottom: 0 !important;
  margin-top: 80px;
  margin-left: 4px;
  padding: 8px;
  max-height: calc(100% - 84px) !important;
  border-radius: 7px;

  &.v-theme--dark {
    background-color: #232b36 !important;
  }

  &.v-theme--light {
    background-color: #FFFFFF !important
  }

  :deep(.v-navigation-drawer__content) {
    overflow-x: auto;
  }

  @media only screen and (max-width: 600px) {
    & {
      margin-top: 80px;
      margin-left: 0;
      border-radius: 0;
      max-height: calc(100% - 84px) !important;
    }

    &.v-navigation-drawer--active {
      width: 100vw !important;
    }
  }
}

/* Active item color */
.console-navigation .v-list-item--active {
  color: #3dabff !important;
  border-radius: 10px;
}

.console-navigation .v-list-item {
  min-height: 56px;
}

.console-navigation .v-list-subheader {
  font-size: 1.05rem;
  font-weight: 500;
  padding-left: 0;
}

.console-navigation > .v-list-subheader > .v-icon {
  padding-left: 0;
  font-size: 1.4rem;
  margin-left: 0.5rem;
}

.v-theme--dark .console-navigation {
  background-color: #232b36 !important;
}

/* Updated for Vuetify 3 */
.v-theme--dark .console-navigation {
  background-color: #232b36 !important;
}

/* Button disabled state */
.v-btn--disabled.v-btn--variant-elevated {
  background-color: #f5f5f5 !important;
}

.v-theme--dark .console-navigation a:hover {
  text-decoration: none;
}
</style>
